// import { useEffect, useState } from "react";
// import { db } from "../../firebase";
// import { collection, getDocs } from "firebase/firestore";
// import AddPromoCode from "./addPromoCode";

// const PromoList = () => {
//   const [promos, setPromos] = useState([]);
//   const [showAddForm, setShowAddForm] = useState(false);

//   const fetchPromos = async () => {
//     const snapshot = await getDocs(collection(db, "promo"));
//     const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//     setPromos(list);
//   };

//   useEffect(() => {
//     fetchPromos();
//   }, []);

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Список усіх промокодів</h2>
//       <button onClick={() => setShowAddForm(true)} style={{ marginBottom: 20 }}>
//         Додати промокод
//       </button>
//       <table border="1" cellPadding="8">
//         <thead>
//           <tr>
//             <th>Код</th>
//             <th>Знижка</th>
//             <th>Тип</th>
//             <th>Значення</th>
//             <th>Одноразовий</th>
//             <th>Дійсний з</th>
//             <th>Дійсний до</th>
//             <th>Опис</th>
//           </tr>
//         </thead>
//         <tbody>
//           {promos.map((promo) => (
//             <tr key={promo.id}>
//               <td>{promo.code}</td>
//               <td>{promo.discount}%</td>
//               <td>{promo.appliesTo?.type}</td>
//               <td>
//                 {promo.appliesTo?.values?.map((v, i) => (
//                   <div key={i}>{v}</div>
//                 ))}
//               </td>
//               <td>{promo.isSingleUse ? "Так" : "Ні"}</td>
//               <td>
//                 {promo.expiresFrom
//                   ? new Date(promo.expiresFrom).toLocaleDateString()
//                   : "-"}
//               </td>
//               <td>
//                 {promo.expiresAt
//                   ? new Date(promo.expiresAt).toLocaleDateString()
//                   : "-"}
//               </td>
//               <td>{promo.description}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {showAddForm && (
//         <AddPromoCode
//           onClose={() => {
//             setShowAddForm(false);
//             fetchPromos();
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default PromoList;
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  serverTimestamp,
  deleteDoc,
} from "firebase/firestore";
import AddPromoCode from "./addPromoCode";

const PromoList = () => {
  const [promos, setPromos] = useState([]);
  const [formMode, setFormMode] = useState(null); // "add" or "edit"
  const [activePromo, setActivePromo] = useState(null);

  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [description, setDescription] = useState("");
  const [isSingleUse, setIsSingleUse] = useState(false);
  const [expiresFrom, setExpiresFrom] = useState("");
  const [expiresTo, setExpiresTo] = useState("");

  const [products, setProducts] = useState([]);
  const [authors, setAuthors] = useState([]);

  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedAuthors, setSelectedAuthors] = useState([]);

  const seriesList = [
    "Я граюся, я вчуся",
    "Вімельбух",
    "Відкривай (енциклопедії і пізнавальні)",
    "Найкраще — дітям",
    "Казкова допомога",
    "Книжка іграшка",
    "Малювальна історія",
    "Рекомендуємо прочитати",
    "Книга нового року",
    "Батькам",
    "Дитячий путівник",
    "2000 вправ та завдань",
    "Цікаво",
    "Святкові",
    "Посібник",
    "Розумний календар",
    "Комікс-книжка",
    "3000 вправ та завдань",
    "Know how",
    "Перше кохання",
    "Книжка-іграшка",
    "Класика",
    "Діточкам",
  ];

  const handleDeletePromo = async (id) => {
    const confirmed = window.confirm(
      "Ви впевнені, що хочете видалити цей промокод?"
    );
    if (confirmed) {
      await deleteDoc(doc(db, "promo", id));
      fetchPromos();
    }
  };

  useEffect(() => {
    fetchPromos();

    const fetchProducts = async () => {
      const snapshot = await getDocs(collection(db, "product"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setProducts(list);
    };

    const fetchAuthors = async () => {
      const snapshot = await getDocs(collection(db, "author"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAuthors(list);
    };

    fetchProducts();
    fetchAuthors();
  }, []);

  const fetchPromos = async () => {
    const snapshot = await getDocs(collection(db, "promo"));
    const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setPromos(list);
  };

  const handleAddPromo = () => {
    setFormMode("add");
    setActivePromo(null);
  };

  const handleEditPromo = (promo) => {
    setFormMode("edit");
    setActivePromo(promo);
    setCode(promo.code);
    setDiscount(promo.discount);
    setDescription(promo.description || "");
    setIsSingleUse(promo.isSingleUse || false);
    setExpiresFrom(promo.expiresFrom ? promo.expiresFrom.split("T")[0] : "");
    setExpiresTo(promo.expiresAt ? promo.expiresAt.split("T")[0] : "");
    setSelectedSeries(promo.appliesTo?.series || []);
    setSelectedProducts(promo.appliesTo?.products || []);
    setSelectedAuthors(promo.appliesTo?.authors || []);
  };

  const handleSubmit = async () => {
    if (!code || !discount || !expiresTo)
      return alert("Заповніть усі обов'язкові поля");

    const ref = doc(db, "promo", code);
    const data = {
      code,
      discount: Number(discount),
      isSingleUse,
      appliesTo: {
        series: selectedSeries,
        products: selectedProducts,
        authors: selectedAuthors,
      },
      expiresFrom: expiresFrom ? new Date(expiresFrom).toISOString() : null,
      expiresAt: new Date(expiresTo).toISOString(),
      description,
    };

    if (formMode === "add") {
      await setDoc(ref, {
        ...data,
        createdAt: serverTimestamp(),
        usedBy: [],
        isActive: true,
      });
    } else if (formMode === "edit") {
      await updateDoc(ref, data);
    }
    setFormMode(null);
    setActivePromo(null);
    fetchPromos();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Список усіх промокодів</h2>
      <button onClick={handleAddPromo} style={{ marginBottom: 20 }}>
        Додати промокод
      </button>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Код</th>
            <th>Знижка</th>
            <th>Серії</th>
            <th>Товари</th>
            <th>Автори</th>
            <th>Одноразовий</th>
            <th>Дійсний з</th>
            <th>Дійсний до</th>
            <th>Опис</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {promos.map((promo) => (
            <tr key={promo.id}>
              <td>{promo.code}</td>
              <td>{promo.discount}%</td>
              <td>
                {promo.appliesTo?.series?.length ? (
                  promo.appliesTo.series.map((s, i) => <div key={i}>{s}</div>)
                ) : (
                  <em>Усі серії</em>
                )}
              </td>
              <td>
                {promo.appliesTo?.products?.length ? (
                  promo.appliesTo.products.map((p, i) => <div key={i}>{p}</div>)
                ) : (
                  <em>Усі товари</em>
                )}
              </td>
              <td>
                {promo.appliesTo?.authors?.length ? (
                  promo.appliesTo.authors.map((a, i) => <div key={i}>{a}</div>)
                ) : (
                  <em>Усі автори</em>
                )}
              </td>
              <td>{promo.isSingleUse ? "Так" : "Ні"}</td>
              <td>
                {promo.expiresFrom
                  ? new Date(promo.expiresFrom).toLocaleDateString()
                  : "-"}
              </td>
              <td>
                {promo.expiresAt
                  ? new Date(promo.expiresAt).toLocaleDateString()
                  : "-"}
              </td>
              <td>{promo.description}</td>
              <td>
                <button onClick={() => handleEditPromo(promo)}>
                  Редагувати
                </button>
                <button onClick={() => handleDeletePromo(promo.id)}>
                  Видалити
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {formMode === "add" && <AddPromoCode onClose={() => setFormMode(null)} />}

      {formMode === "edit" && (
        <div
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            maxWidth: "700px",
            margin: "40px auto",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <h3>Редагувати промокод</h3>

          <div style={{ display: "flex", marginBottom: "10px" }}>
            <input
              placeholder="Промокод"
              value={code}
              disabled
              style={{
                flex: "1",
                padding: "10px",
                marginRight: "10px",
              }}
            />
          </div>

          <input
            type="number"
            placeholder="Знижка %"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
          />

          <textarea
            placeholder="Опис"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              minHeight: "60px",
              marginBottom: "10px",
            }}
          />

          <label style={{ display: "block", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={isSingleUse}
              onChange={(e) => setIsSingleUse(e.target.checked)}
            />{" "}
            Одноразовий
          </label>

          <strong>Серії:</strong>
          <div style={styles.checkGrid}>
            {seriesList.map((ser) => (
              <label key={ser} style={styles.checkbox}>
                <input
                  type="checkbox"
                  checked={selectedSeries.includes(ser)}
                  onChange={() => {
                    if (selectedSeries.includes(ser)) {
                      setSelectedSeries(
                        selectedSeries.filter((s) => s !== ser)
                      );
                    } else {
                      setSelectedSeries([...selectedSeries, ser]);
                    }
                  }}
                />{" "}
                {ser}
              </label>
            ))}
          </div>

          <strong>Товари:</strong>
          <div style={styles.checkGrid}>
            {products.map((p) => (
              <label key={p.id} style={styles.checkbox}>
                <input
                  type="checkbox"
                  checked={selectedProducts.includes(p.id)}
                  onChange={() => {
                    if (selectedProducts.includes(p.id)) {
                      setSelectedProducts(
                        selectedProducts.filter((id) => id !== p.id)
                      );
                    } else {
                      setSelectedProducts([...selectedProducts, p.id]);
                    }
                  }}
                />{" "}
                {p.bookName || p.name}
              </label>
            ))}
          </div>

          <strong>Автори:</strong>
          <div style={styles.checkGrid}>
            {authors.map((a) => (
              <label key={a.id} style={styles.checkbox}>
                <input
                  type="checkbox"
                  checked={selectedAuthors.includes(a.name)}
                  onChange={() => {
                    if (selectedAuthors.includes(a.name)) {
                      setSelectedAuthors(
                        selectedAuthors.filter((name) => name !== a.name)
                      );
                    } else {
                      setSelectedAuthors([...selectedAuthors, a.name]);
                    }
                  }}
                />{" "}
                {a.name}
              </label>
            ))}
          </div>

          <div style={{ margin: "10px 0" }}>
            <label>Дата початку дії (не обов’язково):</label>
            <input
              type="date"
              value={expiresFrom}
              onChange={(e) => setExpiresFrom(e.target.value)}
              style={{ display: "block", marginBottom: "10px" }}
            />
            <label>Дата завершення дії:</label>
            <input
              type="date"
              value={expiresTo}
              onChange={(e) => setExpiresTo(e.target.value)}
              style={{ display: "block" }}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <button
              onClick={handleSubmit}
              style={{
                padding: "10px 15px",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              Зберегти
            </button>
            <button
              onClick={() => setFormMode(null)}
              style={{
                padding: "10px 15px",
                cursor: "pointer",
                background: "#eee",
              }}
            >
              Скасувати
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  checkGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "8px",
    margin: "10px 0",
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
  },
};

export default PromoList;
